import { RPCServerEventsExplicitSubscribe } from "../../services/rpc-server-events.js";
import { useRPCContext } from "../../contexts/RPCContext.js";
import { useCallback, useEffect, useRef } from "react";
// src/hooks/useRPCServerEventHandler/index.tsx
var useRPCServerEventHandler = (event, callback) => {
	const { rpcClient, wsSubscribe, wsUnsubscribe } = useRPCContext();
	const callbackRef = useRef(callback);
	callbackRef.current = callback;
	const msgHandler = useCallback((msg) => {
		if (event === msg.event && typeof callbackRef.current === "function") callbackRef.current(event, msg.data);
	}, [event]);
	useEffect(() => {
		const unsubscribe = rpcClient.subscribeToServerMessages(msgHandler);
		if (RPCServerEventsExplicitSubscribe.has(event)) wsSubscribe(event);
		return () => {
			if (RPCServerEventsExplicitSubscribe.has(event)) wsUnsubscribe(event);
			unsubscribe();
		};
	}, [event]);
};
export { useRPCServerEventHandler };

//# sourceMappingURL=index.js.map